/** gudang (warehouse) copy. Keys are flat, dot-namespaced and stable; placeholders use {name}. */
export const enGudang = {
  'gudang.nav.overview': 'Overview',
  'gudang.overview.title': 'Warehouse',
  'gudang.overview.subtitle': 'Warehouses of {branch}',
  'gudang.overview.warehouses': 'Warehouses',
  'gudang.overview.warehousesDesc':
    'Each active stock location is a warehouse. Zones and bins are set up per warehouse.',
  'gudang.overview.empty': 'No active stock locations yet.',
  'gudang.overview.addLocation': 'Add a location',
  'gudang.overview.default': 'Default',
  'gudang.overview.binsPending': 'No zones or bins yet — stock is kept per location.',
} as const;
